/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { appControllerGetHello } from '../fn/operations/app-controller-get-hello';
import { AppControllerGetHello$Params } from '../fn/operations/app-controller-get-hello';
import { authControllerGetProfile } from '../fn/operations/auth-controller-get-profile';
import { AuthControllerGetProfile$Params } from '../fn/operations/auth-controller-get-profile';
import { authControllerSignIn } from '../fn/operations/auth-controller-sign-in';
import { AuthControllerSignIn$Params } from '../fn/operations/auth-controller-sign-in';
import { DbrAuthSigningResponseDto } from '../models/dbr-auth-signing-response-dto';
import { DbrBalloonCodeResponseDto } from '../models/dbr-balloon-code-response-dto';
import { DbrBalloonEntity } from '../models/dbr-balloon-entity';
import { DbrBalloonEventIdResponseDto } from '../models/dbr-balloon-event-id-response-dto';
import { balloonsControllerBalloonsPosSse } from '../fn/operations/balloons-controller-balloons-pos-sse';
import { BalloonsControllerBalloonsPosSse$Params } from '../fn/operations/balloons-controller-balloons-pos-sse';
import { balloonsControllerCheckIsRegistered } from '../fn/operations/balloons-controller-check-is-registered';
import { BalloonsControllerCheckIsRegistered$Params } from '../fn/operations/balloons-controller-check-is-registered';
import { balloonsControllerCheckSecret } from '../fn/operations/balloons-controller-check-secret';
import { BalloonsControllerCheckSecret$Params } from '../fn/operations/balloons-controller-check-secret';
import { balloonsControllerCreateBulk } from '../fn/operations/balloons-controller-create-bulk';
import { BalloonsControllerCreateBulk$Params } from '../fn/operations/balloons-controller-create-bulk';
import { balloonsControllerDelete } from '../fn/operations/balloons-controller-delete';
import { BalloonsControllerDelete$Params } from '../fn/operations/balloons-controller-delete';
import { balloonsControllerFindAllLaunchedByEvent } from '../fn/operations/balloons-controller-find-all-launched-by-event';
import { BalloonsControllerFindAllLaunchedByEvent$Params } from '../fn/operations/balloons-controller-find-all-launched-by-event';
import { balloonsControllerFindEventIdByCode } from '../fn/operations/balloons-controller-find-event-id-by-code';
import { BalloonsControllerFindEventIdByCode$Params } from '../fn/operations/balloons-controller-find-event-id-by-code';
import { balloonsControllerFindLastCode } from '../fn/operations/balloons-controller-find-last-code';
import { BalloonsControllerFindLastCode$Params } from '../fn/operations/balloons-controller-find-last-code';
import { balloonsControllerFindOneByCode } from '../fn/operations/balloons-controller-find-one-by-code';
import { BalloonsControllerFindOneByCode$Params } from '../fn/operations/balloons-controller-find-one-by-code';
import { balloonsControllerGetBalloonsByEventId } from '../fn/operations/balloons-controller-get-balloons-by-event-id';
import { BalloonsControllerGetBalloonsByEventId$Params } from '../fn/operations/balloons-controller-get-balloons-by-event-id';
import { balloonsControllerGetBalloonsByUserId } from '../fn/operations/balloons-controller-get-balloons-by-user-id';
import { BalloonsControllerGetBalloonsByUserId$Params } from '../fn/operations/balloons-controller-get-balloons-by-user-id';
import { balloonsControllerLaunch } from '../fn/operations/balloons-controller-launch';
import { BalloonsControllerLaunch$Params } from '../fn/operations/balloons-controller-launch';
import { balloonsControllerPatch } from '../fn/operations/balloons-controller-patch';
import { BalloonsControllerPatch$Params } from '../fn/operations/balloons-controller-patch';
import { balloonsControllerSse } from '../fn/operations/balloons-controller-sse';
import { BalloonsControllerSse$Params } from '../fn/operations/balloons-controller-sse';
import { balloonsControllerUpdateImage } from '../fn/operations/balloons-controller-update-image';
import { BalloonsControllerUpdateImage$Params } from '../fn/operations/balloons-controller-update-image';
import { balloonsControllerUpdatePositions } from '../fn/operations/balloons-controller-update-positions';
import { BalloonsControllerUpdatePositions$Params } from '../fn/operations/balloons-controller-update-positions';
import { balloonsControllerUpdateUserId } from '../fn/operations/balloons-controller-update-user-id';
import { BalloonsControllerUpdateUserId$Params } from '../fn/operations/balloons-controller-update-user-id';
import { DbrEventEntity } from '../models/dbr-event-entity';
import { DbrEventResponse } from '../models/dbr-event-response';
import { eventsControllerCreate } from '../fn/operations/events-controller-create';
import { EventsControllerCreate$Params } from '../fn/operations/events-controller-create';
import { eventsControllerDelete } from '../fn/operations/events-controller-delete';
import { EventsControllerDelete$Params } from '../fn/operations/events-controller-delete';
import { eventsControllerFindAll } from '../fn/operations/events-controller-find-all';
import { EventsControllerFindAll$Params } from '../fn/operations/events-controller-find-all';
import { eventsControllerFindOne } from '../fn/operations/events-controller-find-one';
import { EventsControllerFindOne$Params } from '../fn/operations/events-controller-find-one';
import { eventsControllerFindOneByIdOrName } from '../fn/operations/events-controller-find-one-by-id-or-name';
import { EventsControllerFindOneByIdOrName$Params } from '../fn/operations/events-controller-find-one-by-id-or-name';
import { eventsControllerPatch } from '../fn/operations/events-controller-patch';
import { EventsControllerPatch$Params } from '../fn/operations/events-controller-patch';
import { DbrIdResultClass } from '../models/dbr-id-result-class';
import { DbrMessageEvent } from '../models/dbr-message-event';
import { DbrRegistrationInfosDto } from '../models/dbr-registration-infos-dto';
import { DbrSuccessResponseDto } from '../models/dbr-success-response-dto';
import { DbrUserEntity } from '../models/dbr-user-entity';
import { DbrUserIsAdminResponseDto } from '../models/dbr-user-is-admin-response-dto';
import { usersControllerCreate } from '../fn/operations/users-controller-create';
import { UsersControllerCreate$Params } from '../fn/operations/users-controller-create';
import { usersControllerDelete } from '../fn/operations/users-controller-delete';
import { UsersControllerDelete$Params } from '../fn/operations/users-controller-delete';
import { usersControllerFindAll } from '../fn/operations/users-controller-find-all';
import { UsersControllerFindAll$Params } from '../fn/operations/users-controller-find-all';
import { usersControllerFindAllByEventId } from '../fn/operations/users-controller-find-all-by-event-id';
import { UsersControllerFindAllByEventId$Params } from '../fn/operations/users-controller-find-all-by-event-id';
import { usersControllerFindByEmail } from '../fn/operations/users-controller-find-by-email';
import { UsersControllerFindByEmail$Params } from '../fn/operations/users-controller-find-by-email';
import { usersControllerFindOne } from '../fn/operations/users-controller-find-one';
import { UsersControllerFindOne$Params } from '../fn/operations/users-controller-find-one';
import { usersControllerIsAdmin } from '../fn/operations/users-controller-is-admin';
import { UsersControllerIsAdmin$Params } from '../fn/operations/users-controller-is-admin';
import { usersControllerPatch } from '../fn/operations/users-controller-patch';
import { UsersControllerPatch$Params } from '../fn/operations/users-controller-patch';

@Injectable({ providedIn: 'root' })
export class DbrApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appControllerGetHello()` */
  static readonly AppControllerGetHelloPath = '/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerGetHello()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerGetHello$Response(params?: AppControllerGetHello$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appControllerGetHello(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerGetHello$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerGetHello(params?: AppControllerGetHello$Params, context?: HttpContext): Observable<void> {
    return this.appControllerGetHello$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `balloonsControllerCreateBulk()` */
  static readonly BalloonsControllerCreateBulkPath = '/balloons/bulk';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerCreateBulk()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerCreateBulk$Response(params: BalloonsControllerCreateBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return balloonsControllerCreateBulk(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerCreateBulk$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerCreateBulk(params: BalloonsControllerCreateBulk$Params, context?: HttpContext): Observable<void> {
    return this.balloonsControllerCreateBulk$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `balloonsControllerFindLastCode()` */
  static readonly BalloonsControllerFindLastCodePath = '/balloons/last-code';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerFindLastCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerFindLastCode$Response(params?: BalloonsControllerFindLastCode$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrBalloonCodeResponseDto>> {
    return balloonsControllerFindLastCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerFindLastCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerFindLastCode(params?: BalloonsControllerFindLastCode$Params, context?: HttpContext): Observable<DbrBalloonCodeResponseDto> {
    return this.balloonsControllerFindLastCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrBalloonCodeResponseDto>): DbrBalloonCodeResponseDto => r.body)
    );
  }

  /** Path part for operation `balloonsControllerFindOneByCode()` */
  static readonly BalloonsControllerFindOneByCodePath = '/balloons/bycode/{code}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerFindOneByCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerFindOneByCode$Response(params: BalloonsControllerFindOneByCode$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrBalloonEntity>> {
    return balloonsControllerFindOneByCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerFindOneByCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerFindOneByCode(params: BalloonsControllerFindOneByCode$Params, context?: HttpContext): Observable<DbrBalloonEntity> {
    return this.balloonsControllerFindOneByCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrBalloonEntity>): DbrBalloonEntity => r.body)
    );
  }

  /** Path part for operation `balloonsControllerFindEventIdByCode()` */
  static readonly BalloonsControllerFindEventIdByCodePath = '/balloons/eventid/{code}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerFindEventIdByCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerFindEventIdByCode$Response(params: BalloonsControllerFindEventIdByCode$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrBalloonEventIdResponseDto>> {
    return balloonsControllerFindEventIdByCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerFindEventIdByCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerFindEventIdByCode(params: BalloonsControllerFindEventIdByCode$Params, context?: HttpContext): Observable<DbrBalloonEventIdResponseDto> {
    return this.balloonsControllerFindEventIdByCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrBalloonEventIdResponseDto>): DbrBalloonEventIdResponseDto => r.body)
    );
  }

  /** Path part for operation `balloonsControllerFindAllLaunchedByEvent()` */
  static readonly BalloonsControllerFindAllLaunchedByEventPath = '/balloons/launched/{eventid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerFindAllLaunchedByEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerFindAllLaunchedByEvent$Response(params: BalloonsControllerFindAllLaunchedByEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrBalloonEntity>>> {
    return balloonsControllerFindAllLaunchedByEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerFindAllLaunchedByEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerFindAllLaunchedByEvent(params: BalloonsControllerFindAllLaunchedByEvent$Params, context?: HttpContext): Observable<Array<DbrBalloonEntity>> {
    return this.balloonsControllerFindAllLaunchedByEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DbrBalloonEntity>>): Array<DbrBalloonEntity> => r.body)
    );
  }

  /** Path part for operation `balloonsControllerUpdateUserId()` */
  static readonly BalloonsControllerUpdateUserIdPath = '/balloons/userid';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerUpdateUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerUpdateUserId$Response(params: BalloonsControllerUpdateUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return balloonsControllerUpdateUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerUpdateUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerUpdateUserId(params: BalloonsControllerUpdateUserId$Params, context?: HttpContext): Observable<void> {
    return this.balloonsControllerUpdateUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `balloonsControllerCheckIsRegistered()` */
  static readonly BalloonsControllerCheckIsRegisteredPath = '/balloons/registered/{code}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerCheckIsRegistered()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerCheckIsRegistered$Response(params: BalloonsControllerCheckIsRegistered$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrRegistrationInfosDto>> {
    return balloonsControllerCheckIsRegistered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerCheckIsRegistered$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerCheckIsRegistered(params: BalloonsControllerCheckIsRegistered$Params, context?: HttpContext): Observable<DbrRegistrationInfosDto> {
    return this.balloonsControllerCheckIsRegistered$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrRegistrationInfosDto>): DbrRegistrationInfosDto => r.body)
    );
  }

  /** Path part for operation `balloonsControllerCheckSecret()` */
  static readonly BalloonsControllerCheckSecretPath = '/balloons/secret';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerCheckSecret()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerCheckSecret$Response(params: BalloonsControllerCheckSecret$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrSuccessResponseDto>> {
    return balloonsControllerCheckSecret(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerCheckSecret$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerCheckSecret(params: BalloonsControllerCheckSecret$Params, context?: HttpContext): Observable<DbrSuccessResponseDto> {
    return this.balloonsControllerCheckSecret$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrSuccessResponseDto>): DbrSuccessResponseDto => r.body)
    );
  }

  /** Path part for operation `balloonsControllerUpdateImage()` */
  static readonly BalloonsControllerUpdateImagePath = '/balloons/image/{balloonCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerUpdateImage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerUpdateImage$Response(params: BalloonsControllerUpdateImage$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrBalloonEntity>> {
    return balloonsControllerUpdateImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerUpdateImage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerUpdateImage(params: BalloonsControllerUpdateImage$Params, context?: HttpContext): Observable<DbrBalloonEntity> {
    return this.balloonsControllerUpdateImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrBalloonEntity>): DbrBalloonEntity => r.body)
    );
  }

  /** Path part for operation `balloonsControllerBalloonsPosSse()` */
  static readonly BalloonsControllerBalloonsPosSsePath = '/balloons/balloons-pos-sse/{eventid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerBalloonsPosSse()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerBalloonsPosSse$Response(params: BalloonsControllerBalloonsPosSse$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrMessageEvent>> {
    return balloonsControllerBalloonsPosSse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerBalloonsPosSse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerBalloonsPosSse(params: BalloonsControllerBalloonsPosSse$Params, context?: HttpContext): Observable<DbrMessageEvent> {
    return this.balloonsControllerBalloonsPosSse$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrMessageEvent>): DbrMessageEvent => r.body)
    );
  }

  /** Path part for operation `balloonsControllerSse()` */
  static readonly BalloonsControllerSsePath = '/balloons/launch-sse/{eventid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerSse()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerSse$Response(params: BalloonsControllerSse$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrMessageEvent>> {
    return balloonsControllerSse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerSse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerSse(params: BalloonsControllerSse$Params, context?: HttpContext): Observable<DbrMessageEvent> {
    return this.balloonsControllerSse$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrMessageEvent>): DbrMessageEvent => r.body)
    );
  }

  /** Path part for operation `balloonsControllerLaunch()` */
  static readonly BalloonsControllerLaunchPath = '/balloons/launch/{balloonCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerLaunch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerLaunch$Response(params: BalloonsControllerLaunch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return balloonsControllerLaunch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerLaunch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerLaunch(params: BalloonsControllerLaunch$Params, context?: HttpContext): Observable<void> {
    return this.balloonsControllerLaunch$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `balloonsControllerUpdatePositions()` */
  static readonly BalloonsControllerUpdatePositionsPath = '/balloons/update-positions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerUpdatePositions()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerUpdatePositions$Response(params?: BalloonsControllerUpdatePositions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return balloonsControllerUpdatePositions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerUpdatePositions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerUpdatePositions(params?: BalloonsControllerUpdatePositions$Params, context?: HttpContext): Observable<void> {
    return this.balloonsControllerUpdatePositions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `balloonsControllerGetBalloonsByUserId()` */
  static readonly BalloonsControllerGetBalloonsByUserIdPath = '/balloons/byuserid/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerGetBalloonsByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerGetBalloonsByUserId$Response(params: BalloonsControllerGetBalloonsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrBalloonEntity>>> {
    return balloonsControllerGetBalloonsByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerGetBalloonsByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerGetBalloonsByUserId(params: BalloonsControllerGetBalloonsByUserId$Params, context?: HttpContext): Observable<Array<DbrBalloonEntity>> {
    return this.balloonsControllerGetBalloonsByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DbrBalloonEntity>>): Array<DbrBalloonEntity> => r.body)
    );
  }

  /** Path part for operation `balloonsControllerGetBalloonsByEventId()` */
  static readonly BalloonsControllerGetBalloonsByEventIdPath = '/balloons/{eventId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerGetBalloonsByEventId()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerGetBalloonsByEventId$Response(params: BalloonsControllerGetBalloonsByEventId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrBalloonEntity>>> {
    return balloonsControllerGetBalloonsByEventId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerGetBalloonsByEventId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerGetBalloonsByEventId(params: BalloonsControllerGetBalloonsByEventId$Params, context?: HttpContext): Observable<Array<DbrBalloonEntity>> {
    return this.balloonsControllerGetBalloonsByEventId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DbrBalloonEntity>>): Array<DbrBalloonEntity> => r.body)
    );
  }

  /** Path part for operation `balloonsControllerDelete()` */
  static readonly BalloonsControllerDeletePath = '/balloons/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerDelete$Response(params: BalloonsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return balloonsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  balloonsControllerDelete(params: BalloonsControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.balloonsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `balloonsControllerPatch()` */
  static readonly BalloonsControllerPatchPath = '/balloons';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `balloonsControllerPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerPatch$Response(params: BalloonsControllerPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return balloonsControllerPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `balloonsControllerPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  balloonsControllerPatch(params: BalloonsControllerPatch$Params, context?: HttpContext): Observable<void> {
    return this.balloonsControllerPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventsControllerFindAll()` */
  static readonly EventsControllerFindAllPath = '/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsControllerFindAll$Response(params?: EventsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrEventEntity>>> {
    return eventsControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsControllerFindAll(params?: EventsControllerFindAll$Params, context?: HttpContext): Observable<Array<DbrEventEntity>> {
    return this.eventsControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DbrEventEntity>>): Array<DbrEventEntity> => r.body)
    );
  }

  /** Path part for operation `eventsControllerCreate()` */
  static readonly EventsControllerCreatePath = '/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsControllerCreate$Response(params: EventsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrIdResultClass>> {
    return eventsControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsControllerCreate(params: EventsControllerCreate$Params, context?: HttpContext): Observable<DbrIdResultClass> {
    return this.eventsControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrIdResultClass>): DbrIdResultClass => r.body)
    );
  }

  /** Path part for operation `eventsControllerPatch()` */
  static readonly EventsControllerPatchPath = '/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsControllerPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsControllerPatch$Response(params: EventsControllerPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return eventsControllerPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsControllerPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventsControllerPatch(params: EventsControllerPatch$Params, context?: HttpContext): Observable<void> {
    return this.eventsControllerPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventsControllerFindOne()` */
  static readonly EventsControllerFindOnePath = '/events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsControllerFindOne$Response(params: EventsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrEventEntity>> {
    return eventsControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsControllerFindOne(params: EventsControllerFindOne$Params, context?: HttpContext): Observable<DbrEventEntity> {
    return this.eventsControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrEventEntity>): DbrEventEntity => r.body)
    );
  }

  /** Path part for operation `eventsControllerDelete()` */
  static readonly EventsControllerDeletePath = '/events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsControllerDelete$Response(params: EventsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return eventsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsControllerDelete(params: EventsControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.eventsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventsControllerFindOneByIdOrName()` */
  static readonly EventsControllerFindOneByIdOrNamePath = '/events/id-or-name/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsControllerFindOneByIdOrName()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsControllerFindOneByIdOrName$Response(params: EventsControllerFindOneByIdOrName$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrEventResponse>> {
    return eventsControllerFindOneByIdOrName(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventsControllerFindOneByIdOrName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsControllerFindOneByIdOrName(params: EventsControllerFindOneByIdOrName$Params, context?: HttpContext): Observable<DbrEventResponse> {
    return this.eventsControllerFindOneByIdOrName$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrEventResponse>): DbrEventResponse => r.body)
    );
  }

  /** Path part for operation `usersControllerFindAll()` */
  static readonly UsersControllerFindAllPath = '/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindAll$Response(params?: UsersControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrUserEntity>>> {
    return usersControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindAll(params?: UsersControllerFindAll$Params, context?: HttpContext): Observable<Array<DbrUserEntity>> {
    return this.usersControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DbrUserEntity>>): Array<DbrUserEntity> => r.body)
    );
  }

  /** Path part for operation `usersControllerCreate()` */
  static readonly UsersControllerCreatePath = '/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerCreate$Response(params: UsersControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrIdResultClass>> {
    return usersControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerCreate(params: UsersControllerCreate$Params, context?: HttpContext): Observable<DbrIdResultClass> {
    return this.usersControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrIdResultClass>): DbrIdResultClass => r.body)
    );
  }

  /** Path part for operation `usersControllerPatch()` */
  static readonly UsersControllerPatchPath = '/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerPatch$Response(params: UsersControllerPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return usersControllerPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerPatch(params: UsersControllerPatch$Params, context?: HttpContext): Observable<void> {
    return this.usersControllerPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `usersControllerFindAllByEventId()` */
  static readonly UsersControllerFindAllByEventIdPath = '/users/by-event-id/{eventId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerFindAllByEventId()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindAllByEventId$Response(params: UsersControllerFindAllByEventId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrUserEntity>>> {
    return usersControllerFindAllByEventId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerFindAllByEventId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindAllByEventId(params: UsersControllerFindAllByEventId$Params, context?: HttpContext): Observable<Array<DbrUserEntity>> {
    return this.usersControllerFindAllByEventId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DbrUserEntity>>): Array<DbrUserEntity> => r.body)
    );
  }

  /** Path part for operation `usersControllerFindOne()` */
  static readonly UsersControllerFindOnePath = '/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindOne$Response(params: UsersControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrUserEntity>> {
    return usersControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindOne(params: UsersControllerFindOne$Params, context?: HttpContext): Observable<DbrUserEntity> {
    return this.usersControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrUserEntity>): DbrUserEntity => r.body)
    );
  }

  /** Path part for operation `usersControllerDelete()` */
  static readonly UsersControllerDeletePath = '/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerDelete$Response(params: UsersControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return usersControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerDelete(params: UsersControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.usersControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `usersControllerFindByEmail()` */
  static readonly UsersControllerFindByEmailPath = '/users/byemail/{email}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerFindByEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindByEmail$Response(params?: UsersControllerFindByEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrUserEntity>> {
    return usersControllerFindByEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerFindByEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersControllerFindByEmail(params?: UsersControllerFindByEmail$Params, context?: HttpContext): Observable<DbrUserEntity> {
    return this.usersControllerFindByEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrUserEntity>): DbrUserEntity => r.body)
    );
  }

  /** Path part for operation `usersControllerIsAdmin()` */
  static readonly UsersControllerIsAdminPath = '/users/is-admin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersControllerIsAdmin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerIsAdmin$Response(params: UsersControllerIsAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrUserIsAdminResponseDto>> {
    return usersControllerIsAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersControllerIsAdmin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersControllerIsAdmin(params: UsersControllerIsAdmin$Params, context?: HttpContext): Observable<DbrUserIsAdminResponseDto> {
    return this.usersControllerIsAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrUserIsAdminResponseDto>): DbrUserIsAdminResponseDto => r.body)
    );
  }

  /** Path part for operation `authControllerSignIn()` */
  static readonly AuthControllerSignInPath = '/auth/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerSignIn()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerSignIn$Response(params: AuthControllerSignIn$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrAuthSigningResponseDto>> {
    return authControllerSignIn(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerSignIn$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerSignIn(params: AuthControllerSignIn$Params, context?: HttpContext): Observable<DbrAuthSigningResponseDto> {
    return this.authControllerSignIn$Response(params, context).pipe(
      map((r: StrictHttpResponse<DbrAuthSigningResponseDto>): DbrAuthSigningResponseDto => r.body)
    );
  }

  /** Path part for operation `authControllerGetProfile()` */
  static readonly AuthControllerGetProfilePath = '/auth/profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerGetProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerGetProfile$Response(params?: AuthControllerGetProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authControllerGetProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerGetProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerGetProfile(params?: AuthControllerGetProfile$Params, context?: HttpContext): Observable<void> {
    return this.authControllerGetProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
